import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from "react-redux"
import { isEtikAuthorized } from '../helper/authorizedUsers'

const EtikRoute = () => {

  const { currentUser } = useSelector((state) => state.auth)

  // Kullanıcı login değilse login sayfasına yönlendir
  if (!currentUser) {
    return <Navigate to="/login" />
  }

  // Kullanıcı yetkili değilse erişim reddedildi sayfasına yönlendir
  if (!isEtikAuthorized(currentUser)) {
    return <Navigate to="/access-denied" />
  }

  // Yetkili kullanıcı için içeriği göster
  return <Outlet />
}

export default EtikRoute
